import React from "react";
import IconComponent from "../../cubeComponent/icons";
import useUserModuleAccess from "../../services/userModuleAccessBySheetHook";
import { useTranslation } from "@i18n";
import Text from "../../cubeComponent/html/Text/Text";
import { useSelector } from "react-redux";
import { PORTAL_HALF_SEAT } from "helpers";
import { RootState } from "@Reducers/index";

/**
 * One entry of the project sidebar mapper. The slice is exported as `any`
 * (`reducers/projectSetting.ts`, outside this module), so the shape is named here from what is read.
 */
type SidebarIconEntry = { id?: string | number; svg?: string; toolTip?: React.ReactNode };

function ProjectModuleNoAccessIllustration({ checkForPartialSeat = false }: { checkForPartialSeat?: boolean }) {
  const moduleAccess = useUserModuleAccess();
  const { t } = useTranslation();
  const projectSideBarIconsAndNameMapper = useSelector((state: RootState) => state.projectSideBarIconsAndNameMapper);
  const currentSelectedSidebarCell = useSelector((state: RootState) => state.currentSelectedSidebarCell);
  const selectedIconDetails = (projectSideBarIconsAndNameMapper as SidebarIconEntry[]).find(
    (icon: SidebarIconEntry) => icon.id == currentSelectedSidebarCell,
  );

  return (
    selectedIconDetails && (
      <div className="flex h-full w-full flex-col p-12 bg-surface_white">
        <div className="flex gap-2 w-full justify-center text-2xl text-text_light">
          <IconComponent name={selectedIconDetails.svg} color="#666A84" showGradient width="2rem" height="2rem" />
          {selectedIconDetails.toolTip}
        </div>
        <div className="flex h-full items-center justify-center">
          <div
            className={`flex flex-col gap-4 ${checkForPartialSeat && moduleAccess.portalSeat == PORTAL_HALF_SEAT ? "w-[26.5rem]" : "w-100"} text-center items-center`}
          >
            <IconComponent name="NoSub" className="w-[19rem]" width="15rem" height="15rem" />
            <Text sx={{ whiteSpace: "normal" }} className="text-2xl text-text_light">
              {t("Access Restricted")}
            </Text>
            {moduleAccess.isPmPartialSeatPmModule ? (
              <Text sx={{ whiteSpace: "normal" }} className="text-lg text-text_light">
                {t("Your assigned Seat does not allow you to access this Module. Please use our Mobile App.")}
              </Text>
            ) : (
              <Text sx={{ whiteSpace: "normal" }} className="text-lg text-text_light">
                {t("Your assigned Seat does not allow you to access this Module. Please contact your Admin.")}
              </Text>
            )}
          </div>
        </div>
      </div>
    )
  );
}

export default ProjectModuleNoAccessIllustration;
